/* ============================================================================
   Perla — ROUND 33/19. Miglioramenti dell'editor di personalizzazione.

   REGOLA DI QUESTO FILE: non tocca assets/global.js e non parla mai con
   Printify/Printful. Si aggancia soltanto agli hook data-* che il markup gia'
   espone, e quando aggiunge una foto lo fa passando i file all'<input
   type="file"> esistente — cioe' esattamente la stessa strada del click su
   "+ Foto". Il percorso che porta il composito alla stampa (composeAndUpload /
   writePropData in global.js) resta intatto: se questo file non venisse
   caricato del tutto, l'editor funzionerebbe come nel Round 16.

   Otto interventi:
     0. Invito a ruotare/schermo intero sui prodotti lunghi e stretti.
     1. Trascina-e-rilascia una foto sul riquadro.
     2. Stato vuoto: nasconde/mostra il suggerimento in base al pannello livelli.
     3. Anteprima del nome che segue davvero il font/colore scelto.
     4. Stati di caricamento, errore e "riprova" sull'anteprima reale.
     5. Galleria prodotto: via i file di stampa, che non sono fotografie.
     6. Ogni livello resta dentro l'area di stampa, non solo il marchio.
     7. La misura scelta viaggia con la richiesta del disegno di base.
   ========================================================================= */
(function () {
  'use strict';

  var STR = (window.Perla && window.Perla.strings) || {};
  var IT = (document.documentElement.lang || 'it').toLowerCase().indexOf('it') === 0;

  function each(list, fn) { Array.prototype.forEach.call(list || [], fn); }
  function qs(root, sel) { return root ? root.querySelector(sel) : null; }
  function slice(list) { return Array.prototype.slice.call(list || []); }

  /* -------------------------------------------------------------------------
     7. IL DISEGNO DI BASE DELLA MISURA GIUSTA (ROUND 20)

     Un prodotto Printify non ha UN disegno di base: ne ha uno per gruppo di
     varianti, perche' le misure di stampa non sono la stessa cosa ingrandita.
     Dal manifesto dei file costruiti (generated-designs/usa-print-files):

         cuccia     15600x12600 (1,24)  12750x9750 (1,31)  8850x5850 (1,51)
         tappetino   4800x3000  (1,60)   3150x2400 (1,31)

     global.js chiede /pattern-source con il solo printify_product_id, e il
     server rispondeva col primo gruppo -- che aree-stampa.py ordina per primo
     come il piu' GRANDE. Chi compra la cuccia 28x18 pollici (1,51) riceve
     cosi' il file 1,24: sullo schermo come sfondo dell'area, e in stampa come
     base_image_id, perche' global.js salva quell'id nell'ordine. Il motivo
     esce schiacciato. Sul tappetino sarebbero 1,60 contro 1,31.

     PERCHE' SI AVVOLGE fetch E NON SI CORREGGE global.js.
     Per la stessa ragione scritta in assets/perla-forma.js: global.js e'
     minificato su una riga sola e la sua sorgente non sta nel repository,
     quindi modificarlo vorrebbe dire scrivere alla cieca sul percorso che
     porta il file in stampa. Qui invece non si cambia niente di suo: si
     aggiunge un parametro alla richiesta che fa gia', e il server -- che e'
     nostro, scripts/perla-upload-endpoint.js -- sa cosa farne. Senza quel
     parametro si comporta esattamente come prima, quindi se questo file non
     venisse caricato non si rompe niente: torna il difetto, non un errore.

     L'avvolgimento sta QUI, fuori da init(), di proposito: deve essere in
     piedi prima che global.js chieda, e global.js chiede dentro il suo
     DOMContentLoaded. Questo file e' uno <script> della sezione, quindi il
     suo corpo gira prima.
     ---------------------------------------------------------------------- */
  function varianteDelProdotto(idProdotto) {
    var trovato = '';
    each(document.querySelectorAll('[data-photo-customizer]'), function (c) {
      if (trovato) return;
      if ((c.getAttribute('data-printify-product-id') || '') !== idProdotto) return;
      trovato = c.getAttribute('data-printify-variant-id') || '';
    });
    return trovato;
  }

  function agganciaMisuraAllaRichiesta() {
    if (typeof window.fetch !== 'function' || window.__perlaFetchMisura) return;
    window.__perlaFetchMisura = true;
    var originale = window.fetch;

    window.fetch = function (risorsa, opzioni) {
      try {
        var indirizzo = typeof risorsa === 'string' ? risorsa
          : (risorsa && risorsa.url) || '';
        if (indirizzo && indirizzo.indexOf('/pattern-source') !== -1) {
          // il secondo argomento di URL serve solo a digerire un indirizzo
          // relativo: qui sono assoluti, ma costa una parola e non si rompe.
          var u = new URL(indirizzo, window.location.href);
          if (u.pathname.slice(-15) === '/pattern-source' &&
              !u.searchParams.get('printify_variant_id')) {
            var variante = varianteDelProdotto(
              u.searchParams.get('printify_product_id') || '');
            if (variante) {
              u.searchParams.set('printify_variant_id', variante);
              // Una Request non si modifica: se ne fa una nuova con lo stesso
              // contenuto e l'indirizzo corretto.
              risorsa = (typeof risorsa === 'string')
                ? u.toString()
                : new Request(u.toString(), risorsa);
            }
          }
        }
      } catch (e) {
        // Qualunque cosa vada storta qui, la richiesta parte come sarebbe
        // partita comunque: questo e' un miglioramento, non un passaggio
        // obbligato.
      }
      return originale.apply(this, [risorsa, opzioni]);
    };
  }

  agganciaMisuraAllaRichiesta();

  /* -------------------------------------------------------------------------
     0. PRODOTTI LUNGHI E STRETTI SUL TELEFONO

     L'area di stampa di alcuni prodotti e' una striscia lunghissima, e il
     riquadro ricava l'altezza dalla larghezza disponibile. Su un telefono in
     verticale (circa 330px utili) viene fuori questo:

       collare        25.20 : 1  ->   13 px
       collare_eu     22.76 : 1  ->   14 px
       guinzaglio_eu  56.57 : 1  ->    6 px
       ciotola_eu      8.09 : 1  ->   41 px

     La regola qui e' che si deve continuare a vedere TUTTA la striscia in una
     volta sola: niente riquadro piu' largo dello schermo, niente scorrimento
     laterale, niente frecce. L'unico modo per guadagnare altezza restando
     interi e' guadagnare larghezza, quindi si indirizza la persona dove la
     larghezza c'e' davvero: telefono in orizzontale + schermo intero.

     Da 330px in verticale si passa a circa 800-880px in orizzontale a schermo
     intero (il modale toglie i margini, vedi assets/perla-studio.css): il
     collare passa da 13 a circa 34 px, il guinzaglio EU da 6 a 15. Poco, ma
     e' il massimo possibile senza tagliare la striscia o deformarla — il
     rapporto d'aspetto non e' negoziabile, deve combaciare con l'area di
     stampa reale o il disegno arriverebbe deformato.

     UN PULSANTE SOLO (correzione)
     Questo riquadro creava anche un secondo pulsante "Apri a schermo intero"
     che non faceva altro che premere quello gia' presente nella barra degli
     strumenti. Sul telefono se ne vedevano due, a 190 px di distanza, con
     testi diversi per la stessa identica azione: sembrava che uno dei due
     dovesse fare qualcos'altro. Ora resta la sola spiegazione — che serve,
     perche' dice PERCHE' conviene — e il pulsante e' quello vero, che qui
     sotto viene marcato `is-primary` cosi' si nota.
     ---------------------------------------------------------------------- */
  var WIDE_RATIO = 6;   // sopra questo rapporto la striscia e' inservibile in verticale

  function isNarrow() { return window.matchMedia('(max-width: 749px)').matches; }
  function isPortrait() { return window.matchMedia('(orientation: portrait)').matches; }

  function initWideHint(customizer) {
    var ratio = parseFloat(customizer.getAttribute('data-print-ratio'));
    if (!ratio || !isFinite(ratio) || ratio < WIDE_RATIO) return;

    var viewport = qs(customizer, '[data-fabric-viewport]');
    var fsBtn = qs(customizer, '[data-photo-fullscreen-open]');
    if (!viewport || !viewport.parentNode) return;

    // La striscia ora si vede tutta fin dall'apertura (sezione 9), quindi lo
    // schermo intero non e' piu' l'unica strada: resta pero' quello che la fa
    // vedere piu' grande, ed e' l'azione che conviene di piu' qui.
    if (fsBtn) fsBtn.classList.add('is-primary');

    var hint = document.createElement('div');
    hint.className = 'photo-studio__rotate-hint';
    hint.setAttribute('data-rotate-hint', '');

    var p = document.createElement('p');
    p.className = 'photo-studio__rotate-hint-text';
    hint.appendChild(p);

    viewport.parentNode.insertBefore(hint, viewport);

    function sync() {
      if (!isNarrow()) { hint.hidden = true; return; }
      hint.hidden = false;
      if (isPortrait()) {
        p.textContent = STR.rotateHint || (IT
          ? 'Questo prodotto è una striscia lunga e stretta: qui sopra la vedi tutta intera. Usa «+» per ingrandire e lavorare sui dettagli, «Reset» per tornare a vederla tutta. Girando il telefono in orizzontale diventa più grande.'
          : 'This product is a long, narrow strip: above you can see all of it. Use “+” to zoom in on the details and “Reset” to fit it back. Turning your phone sideways makes it bigger.');
      } else {
        p.textContent = STR.rotateHintLandscape || (IT
          ? 'Usa «+» per ingrandire la striscia e lavorare sui dettagli, «Reset» per tornare a vederla tutta.'
          : 'Use “+” to zoom in on the details and “Reset” to fit the whole strip back.');
      }
    }

    sync();
    window.addEventListener('resize', sync);
    window.addEventListener('orientationchange', sync);
  }

  /* -------------------------------------------------------------------------
     1. TRASCINA E RILASCIA

     Il rilascio non carica niente da solo: costruisce un DataTransfer, lo
     assegna all'input file gia' presente e gli manda un evento 'change'. Da
     li' in poi e' global.js a gestire tutto, identico al click su "+ Foto".
     Se il browser non supporta DataTransfer costruibile (Safari < 14.1) la
     funzione esce e resta il pulsante, che ha sempre funzionato.
     ---------------------------------------------------------------------- */
  function initDragAndDrop(customizer) {
    var wrap = qs(customizer, '[data-fabric-wrap]');
    var input = qs(customizer, '[data-photo-input]');
    if (!wrap || !input) return;

    var depth = 0;

    function accepted(dt) {
      if (!dt) return false;
      if (dt.types && Array.prototype.indexOf.call(dt.types, 'Files') === -1) return false;
      return true;
    }

    wrap.addEventListener('dragenter', function (e) {
      if (!accepted(e.dataTransfer)) return;
      e.preventDefault();
      depth++;
      wrap.classList.add('is-dragover');
    });

    wrap.addEventListener('dragover', function (e) {
      if (!accepted(e.dataTransfer)) return;
      e.preventDefault();
      e.dataTransfer.dropEffect = 'copy';
    });

    wrap.addEventListener('dragleave', function () {
      depth = Math.max(0, depth - 1);
      if (depth === 0) wrap.classList.remove('is-dragover');
    });

    wrap.addEventListener('drop', function (e) {
      if (!accepted(e.dataTransfer)) return;
      e.preventDefault();
      depth = 0;
      wrap.classList.remove('is-dragover');

      var dropped = e.dataTransfer.files;
      if (!dropped || !dropped.length) return;

      // Stesso filtro dell'attributo accept dell'input: se qualcuno trascina un
      // PDF o un HEIC non lo passiamo a global.js, che si aspetta un'immagine
      // nei formati che Printify accetta.
      var ok = [];
      each(dropped, function (f) {
        if (/^image\/(png|jpeg|webp)$/.test(f.type)) ok.push(f);
      });
      if (!ok.length) return;

      var DT = window.DataTransfer;
      if (typeof DT !== 'function') return;
      var box;
      try { box = new DT(); } catch (err) { return; }
      if (!box.items || typeof box.items.add !== 'function') return;

      ok.forEach(function (f) { box.items.add(f); });
      input.files = box.files;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* -------------------------------------------------------------------------
     2. STATO VUOTO

     Non serve sapere niente di Fabric: global.js toglie l'attributo hidden da
     [data-layer-panel] appena esiste almeno un livello, quindi quell'attributo
     e' gia' il segnale "la tela non e' piu' vuota". Un MutationObserver su di
     lui basta, senza ispezionare il canvas.
     ---------------------------------------------------------------------- */
  function initEmptyState(customizer) {
    var empty = qs(customizer, '[data-studio-empty]');
    var layers = qs(customizer, '[data-layer-panel]');
    if (!empty || !layers) return;

    function sync() {
      var isEmpty = layers.hasAttribute('hidden');
      if (isEmpty) empty.removeAttribute('hidden');
      else empty.setAttribute('hidden', '');
    }

    sync();
    new MutationObserver(sync).observe(layers, { attributes: true, attributeFilter: ['hidden'] });
  }

  /* -------------------------------------------------------------------------
     3. ANTEPRIMA DEL NOME COERENTE COL FONT SCELTO

     .name-inline-preview e' l'anteprima sotto al campo del nome (la inserisce
     global.js). Aveva il font fisso su Cormorant Garamond nel CSS: chi
     sceglieva Caveat o Montserrat vedeva qui un carattere diverso da quello
     che sarebbe stato davvero inciso. Ora il CSS legge tre custom properties
     e questa funzione le tiene allineate allo swatch attivo.

     Delegato su document: l'anteprima puo' non esistere ancora quando questo
     file gira, e lo studio viene spostato dentro/fuori dal modale a schermo
     intero (initPhotoStudioFullscreen), quindi i riferimenti diretti
     scadrebbero.
     ---------------------------------------------------------------------- */
  function applyNameStyle(scope) {
    var preview = qs(scope, '.name-inline-preview');
    if (!preview) return;

    var font = qs(scope, '.name-font-swatch.is-active');
    if (font) {
      var family = font.getAttribute('data-name-font');
      var weight = font.getAttribute('data-name-weight');
      if (family) preview.style.setProperty('--name-preview-font', family);
      if (weight) preview.style.setProperty('--name-preview-weight', weight);
    }

    var swatch = qs(scope, '.name-color-swatch.is-active');
    var colour = swatch && swatch.getAttribute('data-name-color-swatch');
    if (!colour) {
      var picker = qs(scope, '[data-name-color-picker]');
      if (picker && picker.value) colour = picker.value;
    }
    if (colour) preview.style.setProperty('--name-preview-color', colour);
  }

  function scopeOf(el) {
    return (el && el.closest && (el.closest('[data-photo-customizer]') || el.closest('.product-personalize'))) || document;
  }

  function initNameStyle() {
    // global.js aggiorna la classe .is-active DOPO il proprio handler di click:
    // il rinvio di un tick evita di leggere lo stato precedente.
    document.addEventListener('click', function (e) {
      var hit = e.target.closest && e.target.closest('[data-name-font], [data-name-color-swatch]');
      if (!hit) return;
      var scope = scopeOf(hit);
      setTimeout(function () { applyNameStyle(scope); }, 0);
    });

    document.addEventListener('input', function (e) {
      if (!e.target.matches || !e.target.matches('[data-name-color-picker]')) return;
      applyNameStyle(scopeOf(e.target));
    });

    each(document.querySelectorAll('[data-photo-customizer]'), applyNameStyle);
  }

  /* -------------------------------------------------------------------------
     4. ANTEPRIMA REALE: CARICAMENTO, ERRORE, RIPROVA

     La generazione passa dai server del fornitore e impiega 9-12 secondi
     (6 tentativi x 1,5s su Printify, 8 x 1,5s su Printful — vedi
     scripts/perla-upload-endpoint.js), e puo' rispondere 504 "anteprima non
     pronta, riprova tra qualche secondo". Prima il pulsante non dava alcun
     segnale: sembrava rotto, e sul 504 l'unica via d'uscita era ricaricare la
     pagina perdendo tutto il design.

     Non intercettiamo la fetch di global.js (sarebbe fragile): mettiamo lo
     stato di attesa al click, e lasciamo che sia la comparsa dei mockup o la
     scrittura di un messaggio da parte di global.js a chiudere l'attesa.
     ---------------------------------------------------------------------- */
  function initMockupFeedback(panel) {
    var btn = qs(panel, '[data-generate-mockup], [data-generate-mockup-shared]');
    var status = qs(panel, '[data-mockup-gen-status], [data-mockup-gen-status-shared]');
    var shelf = qs(panel, '[data-real-mockups], [data-real-mockups-shared]');
    if (!btn || !status) return;

    var mine = false; // distingue le scritture di questo file da quelle di global.js

    // ROUND 60 -- L'ATTESA CHE NON FINIVA MAI.
    //
    // Lo stato "pending" si chiudeva SOLO se global.js scriveva un messaggio o
    // se comparivano le anteprime. Se il servizio non risponde affatto non
    // succede ne' l'una ne' l'altra cosa: il testo "Preparo l'anteprima…"
    // restava li' per sempre, col pulsante "Riprova" nascosto, e l'unica via
    // d'uscita era ricaricare la pagina perdendo tutto il design -- cioe'
    // esattamente il difetto che il commento qui sopra dice di aver chiuso.
    //
    // E non e' un caso raro: il servizio sta su un piano gratuito e a freddo
    // ci mette 31 secondi misurati (perla-editor-sveglia.js registrava 24, e
    // da allora e' peggiorato). Il caso lento e il caso guasto si assomigliano
    // molto, ed e' per questo che la soglia e' 45 e non 30: sotto quella
    // dichiarerei guasto un servizio che sta solo svegliandosi.
    var LIMITE_ATTESA = 45000;
    var attesa = null;

    function fermaAttesa() {
      if (attesa) { clearTimeout(attesa); attesa = null; }
    }

    var retry = document.createElement('button');
    retry.type = 'button';
    retry.className = 'product-personalize__retry';
    retry.textContent = STR.mockupRetry || (IT ? 'Riprova' : 'Try again');
    retry.hidden = true;
    retry.addEventListener('click', function () { btn.click(); });
    status.parentNode.insertBefore(retry, status.nextSibling);

    function setState(name) {
      status.classList.remove('product-personalize__status--pending',
        'product-personalize__status--error',
        'product-personalize__status--success');
      if (name) status.classList.add('product-personalize__status--' + name);
    }

    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      retry.hidden = true;
      mine = true;
      status.textContent = STR.mockupPending || (IT ? 'Preparo l’anteprima…' : 'Building your preview…');
      setState('pending');
      setTimeout(function () { mine = false; }, 0);

      // Se dopo LIMITE_ATTESA non ha risposto ne' global.js ne' lo scaffale
      // delle anteprime, si smette di far aspettare: si dice che non e'
      // riuscita e si SCOPRE "Riprova". Il design resta dov'e'.
      fermaAttesa();
      attesa = setTimeout(function () {
        attesa = null;
        if (!status.classList.contains('product-personalize__status--pending')) return;
        mine = true;
        status.textContent = STR.mockupTimeout
          || (IT ? 'L’anteprima non e’ arrivata in tempo. Riprova: il disegno resta com’e’.'
                 : 'The preview didn’t arrive in time. Try again — your design is safe.');
        setState('error');
        retry.hidden = false;
        setTimeout(function () { mine = false; }, 0);
      }, LIMITE_ATTESA);
    });

    // global.js ha scritto un messaggio: l'attesa e' finita, in un modo o
    // nell'altro. Se nel frattempo sono comparse delle anteprime e' andata
    // bene; altrimenti e' un errore e offriamo di riprovare.
    new MutationObserver(function () {
      if (mine) return;
      // Una risposta e' arrivata: il limite d'attesa non serve piu'.
      fermaAttesa();
      var text = (status.textContent || '').trim();
      if (!text) { setState(null); retry.hidden = true; return; }
      var got = shelf && !shelf.hasAttribute('hidden') && shelf.children.length > 0;
      setState(got ? 'success' : 'error');
      retry.hidden = !!got;
    }).observe(status, { childList: true, characterData: true, subtree: true });

    // Le anteprime possono comparire senza che venga scritto alcun messaggio:
    // in quel caso il successo va rilevato da qui.
    if (shelf) {
      new MutationObserver(function () {
        if (shelf.hasAttribute('hidden') || !shelf.children.length) return;
        if (!status.classList.contains('product-personalize__status--pending')) return;
        fermaAttesa();
        mine = true;
        status.textContent = '';
        setState(null);
        retry.hidden = true;
        setTimeout(function () { mine = false; }, 0);
      }).observe(shelf, { attributes: true, attributeFilter: ['hidden'], childList: true });
    }
  }

  /* -------------------------------------------------------------------------
     5. GALLERIA PRODOTTO: VIA I FILE DI STAMPA (ROUND 19)

     I prodotti EU portano in galleria, dopo il mockup, il proprio file di
     stampa. Su un collare quel file e' 1200 x 53 pixel, una striscia; la
     scheda prodotto lo chiede a width 1200 per la slide e 1400 per
     l'ingrandimento, cioe' lo gonfia di dodici volte dentro un riquadro alto
     quanto la foto principale. E' la "foto sgranata" che si vede scorrendo le
     immagini del prodotto.

     snippets/card-product.liquid gia' evitava lo stesso file come foto al
     passaggio del mouse (Round 18); la galleria non era coperta.

     Perche' qui e non nel Liquid: la galleria vive in tre cicli separati
     dentro un file da 44 KB (slide, pallini, miniature) e i tre indici devono
     restare allineati fra loro e con global.js, che naviga per indice. Qui
     bastano gli hook data-* gia' esposti, e dopo ogni rimozione si
     rinumerano tutti e tre gli elenchi.

     NIENTE viene cancellato da Shopify: quei file sono gli stessi a cui punta
     custom.editor_pattern_image, cioe' lo sfondo dell'area di stampa
     nell'editor. Restano dove sono, semplicemente non si mostrano come se
     fossero fotografie.
     ---------------------------------------------------------------------- */
  var MIN_RATIO = 0.55;   // un mockup fotografico sta sempre vicino al quadrato
  var MAX_RATIO = 1.7;

  function initGalleryClean() {
    var gal = document.querySelector('[data-gallery]');
    if (!gal) return;
    if (gal.querySelectorAll('[data-slide]').length < 2) return;

    function reindex() {
      slice(gal.querySelectorAll('[data-slide]')).forEach(function (s, i) {
        s.setAttribute('data-slide', String(i));
      });
      slice(gal.querySelectorAll('[data-gallery-dot]')).forEach(function (d, i) {
        d.setAttribute('data-gallery-dot', String(i));
        d.setAttribute('aria-label', String(i + 1));
      });
      slice(gal.querySelectorAll('[data-thumb]')).forEach(function (t, i) {
        t.setAttribute('data-index', String(i));
      });
    }

    function drop(slide) {
      var idx = slide.getAttribute('data-slide');
      var dot = gal.querySelector('[data-gallery-dot="' + idx + '"]');
      var thumb = gal.querySelector('[data-thumb][data-index="' + idx + '"]');
      if (dot && dot.parentNode) dot.parentNode.removeChild(dot);
      if (thumb && thumb.parentNode) thumb.parentNode.removeChild(thumb);
      if (slide.parentNode) slide.parentNode.removeChild(slide);
    }

    // true se qualche immagine non era ancora caricata: le proporzioni si
    // leggono da naturalWidth/naturalHeight, che prima valgono zero.
    function sweep() {
      var waiting = false;
      var doomed = [];

      slice(gal.querySelectorAll('[data-slide]')).forEach(function (slide, i) {
        if (i === 0) return;           // la prima resta sempre: mai una galleria vuota
        var img = slide.querySelector('img');
        if (!img) return;
        if (!img.naturalWidth || !img.naturalHeight) { waiting = true; return; }
        var r = img.naturalWidth / img.naturalHeight;
        if (r < MIN_RATIO || r > MAX_RATIO) doomed.push(slide);
      });

      if (doomed.length) {
        doomed.forEach(drop);
        reindex();
        if (gal.querySelectorAll('[data-slide]').length < 2) {
          var dots = gal.querySelector('[data-gallery-dots]');
          var thumbs = gal.querySelector('.product__thumbs');
          if (dots) dots.hidden = true;
          if (thumbs) thumbs.hidden = true;
        }
      }
      return waiting;
    }

    if (!sweep()) return;

    // Le slide oltre la prima hanno loading="lazy": possono caricarsi molto
    // dopo. Si riprova a ogni caricamento e una volta sola a fine pagina.
    slice(gal.querySelectorAll('[data-slide] img')).forEach(function (img) {
      img.addEventListener('load', sweep, { once: true });
      img.addEventListener('error', sweep, { once: true });
    });
    window.addEventListener('load', sweep, { once: true });
  }

  /* -------------------------------------------------------------------------
     6. OGNI LIVELLO RESTA DENTRO L'AREA DI STAMPA

     IL DIFETTO, TROVATO NEL CODICE
     In assets/global.js il guardiano che tiene un livello dentro i bordi si
     chiama keepLogoInBounds, e viene agganciato da installLogo:

         obj.on('moving',   keepLogoInBounds)
         obj.on('scaling',  keepLogoInBounds)
         obj.on('rotating', keepLogoInBounds)

     installLogo pero' si usa SOLO sul marchio, e keepLogoInBounds al suo
     interno guarda soltanto la variabile logoLayer: su qualunque altro
     oggetto non fa niente. Cercato in tutto il file, `nameLayer.on(` non
     compare nemmeno una volta.

     Quindi il nome del cane, i testi aggiuntivi, le foto e gli adesivi non
     hanno nessun limite: si trascinano fuori dal riquadro e ci restano.
     Quello che sta fuori dall'area non viene stampato e il cliente non se ne
     accorge — ordina un collare col nome e riceve un collare senza nome.
     E' il difetto piu' caro dell'editor, perche' si scopre solo col pacco in
     mano.

     PERCHE' SI CORREGGE DA QUI E NON DA global.js
     global.js E' un bundle minificato da 89 KB, e il sorgente leggibile non
     esiste da nessuna parte.

     ROUND 70 — LA NOTA ERA GIUSTA, LA MIA CORREZIONE NO. ROUND 56 aveva
     riscritto qui che "gli 89 KB su due righe sono la copia SERVITA, Shopify
     minifica al volo", dedotto da perla-tocco.css (937 righe in git, 2 sulla
     CDN) e generalizzato a tutto. Per il CSS e' vero; per il JS e' falso, e
     adesso si misura invece di dedurlo: global.js e' in git, recuperato
     dall'Admin API, che rende il file CONSERVATO -- e sono 2 righe per
     89.217 byte, cioe' ~29.700 byte a riga. motion.js: 1 riga, 25.315 byte.
     pearls.js: 1 riga. Gli stessi CSS, dalla stessa chiamata, tornano a 40-70
     byte per riga: base.css 2.282 righe, perla-studio.css 1.030.
     Cioe' il minificato E' il sorgente, per il JS.

     Quindi la ragione di stare qui e' piu' forte di come la raccontava
     ROUND 56, non piu' debole: non e' solo che global.js non si puo'
     rivedere in diff (una riga da 89 KB non la controlla nessuno) -- e' che
     non esiste una versione leggibile da correggere. Un solo carattere
     sbagliato li' dentro spegne tutto il JavaScript del negozio, carrello
     compreso. Qui invece si aggiunge un ascoltatore in piu' su ogni livello:
     se questo file sparisse, l'editor tornerebbe esattamente com'e' oggi.

     COME SI TROVA LA TELA
     Le istanze di fabric.Canvas non sono raggiungibili dal DOM, e global.js
     tiene la sua in una variabile locale (`fc`). Si avvolge allora renderAll,
     che ogni tela chiama sempre e comunque, e la prima chiamata la consegna.
     Cosi' non c'e' nessun vincolo di ordine di caricamento: se la tela e'
     nata prima di questo file, la prossima renderAll la registra lo stesso.
     Il costo e' un confronto booleano per fotogramma.

     LA REGOLA DEL LIMITE
     Se il livello e' piu' piccolo dell'area, ci deve stare dentro tutto.
     Se e' piu' grande — una foto usata come sfondo, un motivo — allora e'
     l'area a dover restare dentro il livello: cosi' non si lascia mai un
     angolo bianco, e insieme non si impedisce di spostarlo.

     LA SCALA NON SI TOCCA MAI. E' una scelta di chi disegna, non un difetto:
     e' la lezione della medaglietta "Blue & Gold", dove "ingrandire fino a
     coprire" aveva peggiorato un prodotto che era gia' giusto.

     IL MARCHIO RESTA A global.js, che gli applica limiti piu' stretti
     (logoSafeBounds) e una scala minima sua: metterci le mani sopra da qui
     vorrebbe dire avere due guardiani che si contraddicono.
     ---------------------------------------------------------------------- */

  function areaSicura(fc, forma) {
    var w = fc.getWidth();
    var h = fc.getHeight();
    // Margine proporzionale: su un collare la tela e' alta 14 px e i 4 px
    // fissi del marchio si mangerebbero piu' di meta' dell'altezza.
    var m = Math.max(1, Math.min(4, Math.min(w, h) * 0.04));
    if (forma !== 'tondo') return { left: m, top: m, right: w - m, bottom: h - m };
    // Medaglietta: l'area e' un quadrato ma il prodotto e' un tondo. Si usa il
    // rettangolo inscritto nel cerchio, gli stessi numeri che global.js usa
    // gia' per il marchio, cosi' i due limiti raccontano la stessa forma.
    var cx = w / 2, cy = h / 2;
    var hw = (w * 0.92 / 2) / Math.SQRT2;
    var hh = (h * 0.92 / 2) / Math.SQRT2;
    return { left: cx - hw, top: cy - hh, right: cx + hw, bottom: cy + hh };
  }

  /* -------------------------------------------------------------------------
     6b. LA BANDANA E' UN TRIANGOLO, E FINORA IL LIMITE ERA UN RETTANGOLO

     IL DIFETTO
     snippets/perla-sagoma.liquid disegna sopra la tela, sulle bandane
     Printify, un triangolo: <polygon points="4,8 96,8 50,92"> in centesimi
     della tela. E' la forma del pezzo, ricalcata dal mockup del fornitore.
     areaSicura() qui sopra pero' torna un RETTANGOLO, quindi il nome del cane
     si trascina benissimo negli angoli in alto e sotto la punta -- fuori dal
     tessuto -- e li' non viene stampato. Il cliente lo scopre col pacco.

     IL LIMITE VERO, IN DUE MOSSE
     A quota y il triangolo e' largo 2 * 0,46 * (0,92 - y) / 0,84 della tela.
     Quindi la larghezza disponibile DIPENDE da quanto si scende, e un
     rettangolo unico non la puo' descrivere. Per un riquadro il punto che
     decide e' il suo bordo BASSO, che e' quello alla quota piu' stretta:

       1. VERTICALE. Il bordo basso non puo' scendere sotto la quota dove il
          triangolo e' ancora largo quanto il riquadro.
       2. ORIZZONTALE. Trovata la quota, si rientra dentro la mezza larghezza
          che il triangolo ha LI'.

     Cosi' il cliente porta il marchio dove vuole dentro la bandana -- non
     dentro una fascia stretta decisa a priori -- e non lo fa mai uscire.

     PERCHE' IL TRIANGOLO DISEGNATO E NON QUELLO DI marchio.py
     scripts/marchio.py ha il suo modello del triangolo (area_sicura), usato
     per decidere dove COMPORRE un marchio fermo: e' una fascia fra il 20% e
     il 60% dell'altezza, cioe' il piu' grande rettangolo comodo, non il
     limite. Qui serve il limite, e deve essere quello che il cliente VEDE: se
     la sagoma dice una cosa e il guardiano un'altra, una delle due mente. Il
     triangolo disegnato e' anche il piu' stretto dei due a mezza altezza
     (17,5% contro 19,2%), quindi si sta dalla parte giusta.

     SE NON CI STA PROPRIO -- un livello piu' grande del triangolo, per esempio
     una foto usata come sfondo -- si torna alla regola vecchia del rettangolo:
     meglio il limite di prima che un riquadro spinto in un angolo.
     ---------------------------------------------------------------------- */

  // Il triangolo della sagoma, in frazioni della tela. Se cambiano qui, vanno
  // cambiati anche in snippets/perla-sagoma.liquid: sono lo stesso disegno.
  var TRI_ALTO = 0.08, TRI_BASSO = 0.92, TRI_MEZZO = 0.46;

  function triangoloDi(fc) {
    var w = fc.getWidth(), h = fc.getHeight();
    return {
      cx: w / 2,
      alto: TRI_ALTO * h,
      basso: TRI_BASSO * h,
      mezzo: TRI_MEZZO * w,
      altezza: (TRI_BASSO - TRI_ALTO) * h
    };
  }

  // La quota piu' bassa a cui il triangolo e' ancora largo `largo`.
  function quotaPerLarghezza(t, largo) {
    return t.basso - t.altezza * Math.min(1, (largo / 2) / t.mezzo);
  }

  // Quanto e' larga meta' stoffa alla quota y (mai negativa).
  function semiLarghezza(t, y) {
    var s = t.mezzo * (t.basso - y) / t.altezza;
    return s > 0 ? s : 0;
  }

  // Vero se un riquadro di questa misura ci sta INTERO da qualche parte.
  function ciStaNelTriangolo(t, largo, alto) {
    if (alto > t.altezza || largo > 2 * t.mezzo) return false;
    return quotaPerLarghezza(t, largo) - alto >= t.alto - 0.5;
  }

  // Di quanto va spostato un segmento [p, p+len] per rispettare [a, b].
  function rientro(p, len, a, b) {
    if (len <= b - a) {                 // ci sta dentro: deve starci tutto
      if (p < a) return a - p;
      if (p + len > b) return b - (p + len);
      return 0;
    }
    if (p > a) return a - p;            // piu' grande dell'area: deve coprirla
    if (p + len < b) return b - (p + len);
    return 0;
  }

  /* -------------------------------------------------------------------------
     6c. IL MARCHIO CHE IL CLIENTE SPOSTA

     Sulle bandane Printify che portano il metafield custom.marchio_mobile il
     marchio Perla non e' piu' cotto dentro il file di stampa: e' un livello
     qui dentro, e il cliente lo trascina dove preferisce. Il file di stampa e'
     il solo motivo (scripts/perla-usa-file-stampa.py, MARCHIO_NELL_EDITOR) e
     il marchio arriva allo stampatore dentro il composito, alla posizione
     scelta. Senza il metafield qui non succede niente e resta tutto com'era.

     SI SPOSTA, NON SI RIMPICCIOLISCE. E' la richiesta, testuale: "poterlo
     spostare ma non rimpicciolire". I lock di fabric fermano le maniglie, ma
     non una obj.set({scaleX}) -- e le frecce della barra livelli fanno
     esattamente quella. Quindi la set() dell'oggetto rifiuta scala e angolo, e
     dentro() li rimette comunque a posto a ogni manovra: due reti, perche'
     questa e' l'unica cosa che il cliente non deve poter fare.

     NIENTE __perlaKind, E NON E' UNA DIMENTICANZA
     global.js guarda __perlaKind dappertutto, e il valore cambia tutto:
       'logo'      protetto da cancella-tutto e dalla lista livelli, ma
                   hasContent() lo IGNORA -- e allora un cliente che non
                   scrive niente manderebbe in stampa una bandana senza
                   marchio, che e' proprio il guasto da evitare;
       qualunque   hasContent() vero (bene), ma compare nella lista livelli
       altro       con il suo cestino, e il marchio si potrebbe cancellare.
     Senza __perlaKind si ha il meglio dei due: renderLayerList() filtra su
     `o.__perlaKind &&`, quindi non compare e non si cancella dalla lista;
     hasContent() e' vero, quindi il composito si costruisce e parte anche se
     il cliente non aggiunge niente. Resta cancella-tutto, che porta via tutto
     cio' che non e' 'logo': il marchio si rimette da solo, qui sotto.
     E' anche l'unico modo che sopravvive all'ANNULLA: la cronologia salva solo
     ["__perlaKind","__perlaHasText","__perlaId"], quindi una bandiera nostra
     andrebbe persa -- mentre "l'immagine senza __perlaKind" si riconosce
     ancora.
     ---------------------------------------------------------------------- */

  function marchioDi(fc) {
    var o = fc.getObjects();
    for (var i = 0; i < o.length; i++) {
      if (o[i].type === 'image' && !o[i].__perlaKind) return o[i];
    }
    return null;
  }

  function scalaAttesa(fc, obj, alt) {
    var lato = Math.min(fc.getWidth(), fc.getHeight());
    return obj.height ? (alt * lato) / obj.height : obj.scaleX || 1;
  }

  function vestiMarchio(obj) {
    obj.set({
      lockScalingX: true, lockScalingY: true, lockUniScaling: true,
      lockRotation: true, lockSkewingX: true, lockSkewingY: true,
      lockMovementX: false, lockMovementY: false,
      hasControls: false, hasBorders: true,
      selectable: true, evented: true, hoverCursor: 'move'
    });
    if (obj.setControlsVisibility) {
      obj.setControlsVisibility({ tl: false, tr: false, bl: false, br: false,
        ml: false, mr: false, mt: false, mb: false, mtr: false });
    }
    if (obj.__perlaSetFisso) return;
    obj.__perlaSetFisso = true;
    var originale = obj.set;
    obj.set = function (chiave, valore) {
      if (chiave && typeof chiave === 'object') {
        var copia = {};
        for (var k in chiave) {
          if (Object.prototype.hasOwnProperty.call(chiave, k) &&
              k !== 'scaleX' && k !== 'scaleY' && k !== 'angle') copia[k] = chiave[k];
        }
        return originale.call(this, copia);
      }
      if (chiave === 'scaleX' || chiave === 'scaleY' || chiave === 'angle') return this;
      return originale.call(this, chiave, valore);
    };
  }

  function montaMarchio(fc, root) {
    var url = root && root.getAttribute('data-marchio-url');
    // window.fabric e non `fabric` nudo: e' l'idioma di questo file (vedi il
    // punto 9), e global.js carica fabric da un CDN solo quando serve.
    var F = window.fabric;
    if (!url || !F || !F.Image) return null;
    var geo = String(root.getAttribute('data-marchio-geo') || '').split(',');
    var cx = parseFloat(geo[0]), cy = parseFloat(geo[1]), alt = parseFloat(geo[2]);
    if (!(cx > 0 && cy > 0 && alt > 0)) return null;

    var riserva = null;

    function posa(img) {
      var w = fc.getWidth(), h = fc.getHeight();
      var scala = scalaAttesa(fc, img, alt);
      // La scala si scrive PRIMA di fc.add(): da li' in poi la set() la
      // rifiuta, ed e' giusto cosi'.
      img.set({ originX: 'center', originY: 'center',
                left: cx * w, top: cy * h, scaleX: scala, scaleY: scala, angle: 0 });
      // Vestito QUI e non solo su object:added: F.Image.fromURL puo'
      // richiamare subito, prima che il guardiano abbia agganciato i suoi
      // ascoltatori, e un marchio senza lock e' un marchio che si ridimensiona.
      vestiMarchio(img);
      fc.add(img);
      // Sotto quello che scrive il cliente, come sul tessuto: fino a ieri il
      // marchio stava DENTRO il motivo, quindi il testo gli passava sopra.
      fc.sendToBack(img);
      img.setCoords();
      fc.requestRenderAll();
    }

    F.Image.fromURL(url, function (img) {
      if (!img || !img.width) return;
      riserva = img;
      posa(img);
    }, { crossOrigin: 'anonymous' });

    // "Cancella tutto" porta via tutto cio' che non e' 'logo', marchio
    // compreso. Si rimette al giro dopo: il composito e' rimandato di 700 ms,
    // quindi quello che parte per lo stampatore ce l'ha gia' dentro.
    fc.on('object:removed', function () {
      if (!riserva) return;
      setTimeout(function () {
        if (!marchioDi(fc)) posa(riserva);
      }, 0);
    });

    return { alt: alt };
  }

  function prendiInCura(fc) {
    fc.__perlaCurata = true;            // per primo: evita il rientro ricorsivo

    var el = fc.lowerCanvasEl;
    var root = el && el.closest ? el.closest('[data-photo-customizer]') : null;
    var tipo = (root && root.getAttribute('data-product-type')) || '';
    var forma = tipo === 'medaglietta' ? 'tondo'
              : tipo === 'bandana' ? 'triangolo' : 'rettangolo';

    var marchio = montaMarchio(fc, root);

    function dentro(obj) {
      if (!obj || obj.group) return;                 // figlio di una selezione
      var suo = marchio && obj === marchioDi(fc);
      if (suo) {
        // La scala e l'angolo tornano quelli di sempre, qualunque cosa sia
        // riuscita a cambiarli (una set() interna, un annulla, un ripristino
        // dalla cronologia).
        var s = scalaAttesa(fc, obj, marchio.alt);
        if (obj.scaleX !== s || obj.scaleY !== s || obj.angle) {
          obj.scaleX = obj.scaleY = s;
          obj.angle = 0;
        }
      } else if (obj.__perlaKind === 'logo' && forma !== 'triangolo') {
        return;                                      // ci pensa gia' global.js
      }
      obj.setCoords();
      var b = obj.getBoundingRect();
      var dx, dy;
      if (forma === 'triangolo') {
        var t = triangoloDi(fc);
        if (!ciStaNelTriangolo(t, b.width, b.height)) {
          var r = areaSicura(fc, forma);
          dx = rientro(b.left, b.width, r.left, r.right);
          dy = rientro(b.top, b.height, r.top, r.bottom);
        } else {
          // Prima il verticale: e' il bordo basso, il piu' stretto, a dire
          // fin dove si puo' scendere. Poi l'orizzontale a quella quota.
          dy = rientro(b.top, b.height, t.alto, quotaPerLarghezza(t, b.width));
          var semi = semiLarghezza(t, b.top + dy + b.height);
          dx = rientro(b.left, b.width, t.cx - semi, t.cx + semi);
        }
      } else {
        var a = areaSicura(fc, forma);
        dx = rientro(b.left, b.width, a.left, a.right);
        dy = rientro(b.top, b.height, a.top, a.bottom);
      }
      if (!dx && !dy) return;
      obj.left += dx;
      obj.top += dy;
      obj.setCoords();
    }

    function sorveglia(obj) {
      if (!obj || obj.__perlaSorvegliato) return;
      obj.__perlaSorvegliato = true;
      obj.on('moving', function () { dentro(obj); });
      obj.on('scaling', function () { dentro(obj); });
      obj.on('rotating', function () { dentro(obj); });
    }

    fc.getObjects().forEach(sorveglia);
    fc.on('object:added', function (e) {
      sorveglia(e.target);
      // Anche quando torna dalla cronologia: loadFromJSON ricostruisce oggetti
      // nuovi, e i lock non sopravvivono per forza alla serializzazione.
      if (marchio && e.target && e.target.type === 'image' && !e.target.__perlaKind) {
        vestiMarchio(e.target);
      }
    });

    // Una selezione multipla e' un oggetto nuovo, creato al volo e mai
    // "aggiunto": va sorvegliata quando nasce, o trascinando due livelli
    // insieme si esce lo stesso.
    fc.on('selection:created', function (e) { sorveglia(e.target || (e.selected && e.selected[0])); });
    fc.on('selection:updated', function (e) { sorveglia(e.target || (e.selected && e.selected[0])); });


    /* -----------------------------------------------------------------------
       6d. I CAMPI PRECISI, E I PULSANTI CHE PROMETTONO QUELLO CHE NON FANNO

       DUE BUCHI VISTI NEL BROWSER, non dedotti: aperta la scheda vera nello
       specchio, trascinato il marchio e guardata la barra dei livelli.

       1. I CAMPI X% / Y% SALTANO IL GUARDIANO. In global.js applyPreciseFields
          fa obj.set({left, top}), setCoords(), renderAll(), scheduleCompose()
          -- e NON emette object:modified. Il nostro dentro() e' agganciato a
          moving/scaling/rotating e a object:modified: da quei campi non passa
          nessuno dei due. Scrivendo X = 99 il livello esce dalla stoffa e ci
          resta. Vale per il marchio e vale per il testo, che il difetto ce
          l'ha da sempre.

       2. LA BARRA PROMETTE DI RIMPICCIOLIRE IL MARCHIO. Le frecce
          ingrandisci/rimpicciolisci e ruota restano accese anche quando il
          livello scelto e' il marchio, dove la scala e' fissa per richiesta.
          La set() dell'oggetto le rifiuta gia' -- non succede niente -- ma un
          pulsante che non fa niente e' peggio di un pulsante che non c'e':
          il cliente pensa che l'editor sia rotto. Si nascondono quando il
          marchio e' selezionato, e tornano per gli altri livelli.
       -------------------------------------------------------------------- */

    function campiPrecisi() {
      if (!root || !root.querySelectorAll) return [];
      return slice(root.querySelectorAll('[data-precise-x],[data-precise-y],[data-precise-rotate]'));
    }

    campiPrecisi().forEach(function (campo) {
      campo.addEventListener('change', function () {
        // dopo global.js, che ha appena scritto left/top/angle
        setTimeout(function () {
          var attivo = fc.getActiveObject();
          if (attivo) { dentro(attivo); fc.requestRenderAll(); }
        }, 0);
      });
    });

    function vestiBarra() {
      if (!root || !root.querySelector) return;
      var suo = marchio && fc.getActiveObject() === marchioDi(fc);
      ['[data-zoom-in-sel]', '[data-zoom-out-sel]',
       '[data-rotate-left-sel]', '[data-rotate-right-sel]'].forEach(function (sel) {
        var b = root.querySelector(sel);
        if (b) b.hidden = !!suo;
      });
      var rot = root.querySelector('[data-precise-rotate]');
      if (rot && rot.parentNode) rot.parentNode.hidden = !!suo;
    }

    fc.on('selection:created', vestiBarra);
    fc.on('selection:updated', vestiBarra);
    fc.on('selection:cleared', vestiBarra);

    // Ultima rete: qualunque cosa sia successa, a fine manovra si controlla.
    // global.js ha gia' il suo object:modified (compone il file di stampa);
    // il nostro e' registrato dopo, ma i livelli sono gia' rientrati durante
    // il trascinamento, quindi quello che global.js compone e' gia' giusto.
    fc.on('object:modified', function (e) {
      dentro(e.target);
      fc.requestRenderAll();
    });
  }

  /* -------------------------------------------------------------------------
     7. IL FILE DI STAMPA ALLA RISOLUZIONE CHE L'AREA CHIEDE

     IL DIFETTO, MISURATO
     In assets/global.js, buildComposite() esporta sempre 2000 px sul lato
     lungo, qualunque sia l'area di stampa:

         var EXPORT_BASE = 2000,
             exportW = ratio >= 1 ? EXPORT_BASE : Math.round(EXPORT_BASE * ratio),
             multiplier = exportW / canvasW;

     Confrontato con le aree vere (scripts/perla-scala-stampa.py):

         guinzaglio EU  12389x219    ->  2000x35     3% dei pixel
         cuccia USA     15600x12600  ->  2000x1615   2%
         collare EU      7169x315    ->  2000x88     8%
         ciotola EU      6496x803    ->  2000x247    9%
         bandana EU      4125x4125   ->  2000x2000  24%

     Il fornitore riceve quell'immagine e la ingrandisce fino all'area: un nome
     scritto su una tela alta 35 px e portato a 219 non e' piu' una scritta, e'
     una sbavatura. E' questo che si vede come "la scritta viene rimpicciolita",
     ed e' anche la seconda causa -- indipendente dalla risoluzione delle
     sorgenti -- del "sembrano impastati" da cui e' partito tutto.

     Le proporzioni invece sono giuste: misurato in Chromium, l'inchiostro
     occupa 0,5043 della tela nell'anteprima e 0,5025 nel file di stampa. Non
     e' un problema di scala, e' di risoluzione.

     COSA FA
     Avvolge toDataURL e alza il moltiplicatore SOLO quando ne arriva uno --
     cioe' solo per il file di stampa. L'anteprima (updateMockupPreview chiama
     toDataURL senza moltiplicatore) resta identica a oggi.

     I TRE LIMITI, E PERCHE' QUESTI
       PIXEL_MAX 16 Mpx: oltre, Safari su iPhone smette di disegnare la tela
       e toDataURL torna un'immagine vuota. Il lato invece puo' arrivare a
       LATO_MAX (12400, il guinzaglio intero) solo se telaRegge() lo prova sul
       telefono che sta disegnando; se no resta a LATO_SICURO, 4096.

       BYTE_MAX: perla-upload-endpoint.js rifiuta oltre MAX_UPLOAD_MB (10 di
       default, ma sul server puo' essere piu' basso). Si misura il risultato e
       se sfora si scende, invece di produrre un file che verrebbe respinto --
       il caricamento non si rompe mai, al massimo si accontenta.

     PERCHE' DA QUI E NON DA global.js: stessa ragione del punto 6. Un bundle
     minificato da 89 KB non si riscrive a mano per cambiare una costante.
     ---------------------------------------------------------------------- */
  /* LATO_MAX era 4096, ma il limite di Safari su iPhone e' l'AREA (circa
     16,7 Mpx), non il lato: una striscia 12400x213 sono 2,6 Mpx. Con 4096 il
     nome sul guinzaglio (12389 px di stampa) partiva tre volte piu' piccolo e
     sul collare (7169) quasi due: in stampa, bordi impastati. Ora il lato
     arriva fino al guinzaglio intero, ma solo se il telefono dimostra di
     reggere quella tela (telaRegge, la prova di un pixel che usa anche la
     libreria canvas-size); se no si torna ai 4096 di prima, che vanno
     ovunque. Un file di stampa vuoto non deve poter uscire mai. */
  var LATO_MAX = 12400;             // il guinzaglio EU e' largo 12389
  var LATO_SICURO = 4096;           // quello che regge qualunque telefono
  var PIXEL_MAX = 16e6;             // il limite vero di Safari su iPhone
  var BYTE_MAX = 8 * 1024 * 1024;   // sotto MAX_UPLOAD_MB, con margine

  var tele = {};
  function telaRegge(w, h) {
    w = Math.ceil(w); h = Math.ceil(h);
    var chiave = w + 'x' + h;
    if (chiave in tele) return tele[chiave];
    var ok = false;
    try {
      var c = document.createElement('canvas');
      c.width = w; c.height = h;
      var x = c.getContext('2d');
      if (x) {
        x.fillStyle = '#132A4A';        // il blu del tema: 19, 42, 74
        x.fillRect(w - 1, h - 1, 1, 1);
        var d = x.getImageData(w - 1, h - 1, 1, 1).data;
        ok = d[2] === 74 && d[3] === 255;
      }
      c.width = 0; c.height = 0;      // la memoria si libera subito
    } catch (err) { ok = false; }
    tele[chiave] = ok;
    return ok;
  }

  function fattore(w, h, lato) {
    return Math.min(lato / Math.max(w, h), Math.sqrt(PIXEL_MAX / (w * h)));
  }

  function quantoSiPuoAlzare(fc, mult) {
    var w = fc.getWidth() * mult;
    var h = fc.getHeight() * mult;
    if (!(w > 0) || !(h > 0)) return 1;
    var k = fattore(w, h, LATO_MAX);
    if (k > 1 && Math.max(w, h) * k > LATO_SICURO && !telaRegge(w * k, h * k)) {
      k = fattore(w, h, LATO_SICURO);
    }
    return k > 1 ? k : 1;           // non si scende mai sotto quello che c'era
  }

  function copia(o) {
    var n = {};
    for (var k in o) { if (Object.prototype.hasOwnProperty.call(o, k)) n[k] = o[k]; }
    return n;
  }

  function byte(dataUrl) {
    var virgola = dataUrl.indexOf(',');
    return Math.round((dataUrl.length - virgola - 1) * 0.75);
  }

  /* -------------------------------------------------------------------------
     8. SCRIVERE IL NOME NON DEVE ALLARGARE LA PAGINA

     IL DIFETTO, RIPRODOTTO
     Sui prodotti a disegno fisso non c'e' nessun campo di testo: il nome si
     scrive DENTRO la tela. Per farlo Fabric crea una textarea invisibile e la
     attacca al <body> alle coordinate del cursore NEL DOCUMENTO:

         this.hiddenTextarea.style.cssText =
           "position: absolute; top: " + t.top + "; left: " + t.left + ...

     Su un collare la tela e' larga 2208 px, quindi quelle coordinate stanno
     oltre i mille. Misurato a 390 px:

         prima di toccare niente   body.scrollWidth   390
         entrando in scrittura     body.scrollWidth  1084   left: 1077 px
         digitando                                          left: 1183 -> 1311

     Il corpo si allarga a ogni carattere. Su un telefono vero e' questo che fa
     rimpicciolire la pagina e scorrere verso sinistra mentre si scrive.

     LA CORREZIONE
     La textarea diventa `fixed` e resta ancorata in alto a sinistra della
     finestra. Fixed non partecipa al calcolo della larghezza del documento,
     quindi la pagina non si allarga piu'; l'elemento resta a fuoco e la
     tastiera continua a funzionare, che e' l'unica cosa per cui serve.

     COSA SI PERDE
     Fabric usa quella posizione per ancorare il riquadro di composizione delle
     tastiere orientali (IME). Su un negozio italiano il compromesso e' facile:
     meglio l'ancoraggio dell'IME in alto a sinistra che la pagina che scappa a
     ogni lettera.
     ---------------------------------------------------------------------- */

  function fissaTextarea(obj) {
    var ta = obj && obj.hiddenTextarea;
    if (!ta) return;
    ta.style.position = 'fixed';
    ta.style.left = '0px';
    ta.style.top = '0px';
    // 16px: sotto questa misura Safari su iPhone ingrandisce la pagina da solo
    // quando un campo prende il fuoco. La textarea e' invisibile lo stesso,
    // perche' Fabric le mette opacity 0.
    ta.style.fontSize = '16px';
    ta.style.width = '1px';
    ta.style.height = '1px';
  }

  /* -------------------------------------------------------------------------
     9. IL NASTRO SI VEDE TUTTO, E SI INGRANDISCE PER LAVORARCI

     IL DIFETTO, MISURATO
     snippets/perla-photo-customizer-side.liquid parte dall'ALTEZZA e lascia
     scorrere la larghezza, per non deformare le proporzioni di stampa:

         studio_h = 2200 / rapporto   (poi limitato fra 80 e 200)
         studio_w = studio_h * rapporto

     Sul collare (22,76:1) vengono 2208 x 97 px dentro una finestra di 350.
     A 390 px di schermo, misurato:

         verticale                 350 x 97   su 2208 x 97   ->  16%
         verticale schermo intero  352 x 97   su 2208 x 97   ->  16%
         orizzontale               760 x 97   su 2208 x 97   ->  34%
         orizzontale + intero      825 x 97   su 2208 x 97   ->  37%

     Lo schermo intero NON cambia niente: sedici per cento prima, sedici dopo.
     Il guinzaglio e' peggio: rapporto 56,57, altezza al minimo di 80, striscia
     larga 4526 px, cioe' circa il sette per cento visibile.

     COSA FA ORA
     All'apertura la striscia sta tutta dentro: si scala di
     `larghezza finestra / larghezza striscia` e la si centra in una banda
     comoda. Si vede un collare intero, sottile e fermo -- che e' quello che il
     prodotto e'. Chi vuole personalizzare ingrandisce con i pulsanti che gia'
     ci sono, e a quel punto la striscia si sposta DENTRO il suo riquadro:
     la pagina non si muove mai di lato.

     PERCHE' CON transform E NON CAMBIANDO width/height
     La tela ha larghezza e altezza in attributi; ridimensionarla via CSS senza
     `height:auto` la deforma, e un riquadro fuori proporzione manda in stampa
     il nome schiacciato. Il transform invece scala tutto insieme, ed e' anche
     il meccanismo che global.js usa gia': fabric calcola il puntatore da
     getBoundingClientRect, che i transform li comprende.

     CHI VINCE SULLO STILE (misurato, non supposto)
     global.js tiene il suo `viewZoom` e nella sua `applyViewZoom` riscrive
     `fabricWrap.style.transform`. Il primo tentativo era registrare i nostri
     ascoltatori sui pulsanti e contare di girare per ultimi: NON funziona.
     Provato nel browser, premendo «+» restava `scale(1.5)`, cioe' il valore
     suo -- lo studio di global.js si avvia dopo di noi, quindi i suoi
     ascoltatori sono registrati dopo i nostri e parlano per ultimi.

     Sull'ordine di registrazione non si puo' fare affidamento. Quindi i tre
     pulsanti si prendono in FASE DI CATTURA sul contenitore, dove si passa
     prima che l'evento arrivi al pulsante, e li' si ferma la propagazione: gli
     ascoltatori di global.js non vengono mai chiamati. Vale solo sui nastri,
     dove initNastro e' attivo; su tutti gli altri prodotti lo zoom del tema
     resta quello di sempre.

     L'osservatore sullo `style` resta come rete: confronta con la stringa che
     abbiamo scritto noi e riscrive solo se qualcuno l'ha cambiata davvero --
     cosi' non reagisce a se stesso e si ferma da solo.
     ---------------------------------------------------------------------- */

  var BANDA_MIN = 96;      // altezza minima della fascia, perche' si veda
  var BANDA_LAVORO = 320;  // altezza a cui si arriva col massimo ingrandimento
  var PASSO = 1.8;
  // ROUND 20 -- QUANTO GRANDE SI APRE UN NASTRO.
  //
  // Fino a ieri si apriva a "tutta": la striscia intera dentro la colonna.
  // Misurato nel browser su tredici schede, a 390 e a 1280, ecco che cosa
  // vuol dire davvero su un'area 56:1 -- l'altezza DISEGNATA all'apertura:
  //
  //     guinzaglio_eu   6,2 px      collare_eu      15,4 px
  //     collare_pelle  31,8 px      ciotola_eu      43,3 px
  //
  // Sei pixel non sono un editor: sono un filo. E la fascia riservata era
  // comunque di 96 px, quindi i novanta rimanenti restavano vuoti.
  //
  // Adesso si apre alla misura in cui si lavora -- la fascia piena -- e si
  // scorre di lato, che e' quello che si fa con un guinzaglio anche in mano.
  // Due freni, perche' "grande" non diventi "perso":
  //   BANDA_MIN / altezza    non piu' alto della fascia che c'e' gia'
  //   SCHERMI * finestra     non piu' largo di quattro schermate
  // e mai sotto `fit`, che resta il minimo: su una ciotola o un collare corto
  // la striscia ci sta tutta e non si tocca niente.
  //
  // Il tasto di ripristino riporta qui; lo zoom meno continua a scendere fino
  // a `fit`, cioe' a vedere tutto il prodotto in una volta.
  var SCHERMI_APERTURA = 4;

  function initNastro(customizer) {
    var viewport = qs(customizer, '[data-fabric-viewport]');
    var wrap = qs(customizer, '[data-fabric-wrap]');
    if (!viewport || !wrap) return;

    var largaW = wrap.offsetWidth;
    var altaW = wrap.offsetHeight;
    var finestra = viewport.clientWidth;
    // Senza misure non si decide niente: se lo studio non e' ancora visibile
    // meglio lasciare tutto com'e' che scalare per zero e sparire.
    if (!largaW || !altaW || !finestra) return;
    // Solo dove serve: se la striscia ci sta gia', non si tocca niente.
    if (largaW <= finestra + 1) return;

    var fit = finestra / largaW;
    var massimo = Math.max(1, Math.min(6, BANDA_LAVORO / altaW));

    // la misura a cui conviene aprire: la fascia piena, ma senza chiedere
    // piu' di quattro schermate di scorrimento, e mai sotto "tutta".
    function apertura() {
      var comoda = Math.min(BANDA_MIN / altaW,
                            (SCHERMI_APERTURA * finestra) / largaW,
                            massimo);
      return Math.max(fit, comoda);
    }

    var scala = apertura();
    var atteso = '';
    var tutta = true;
    var toccata = false;   // l'ha cambiata l'utente, o e' ancora quella d'apertura?
    var appena = true;   // prima applicazione: la striscia va centrata

    function applica() {
      var alta = Math.max(BANDA_MIN, Math.round(altaW * scala));
      var vuoto = Math.max(0, (alta - altaW * scala) / 2);
      atteso = 'translateY(' + vuoto.toFixed(1) + 'px) scale(' + scala.toFixed(4) + ')';
      wrap.style.transformOrigin = '0 0';
      wrap.style.transform = atteso;
      // IL TRANSFORM NON RESTRINGE LO SPAZIO OCCUPATO, i margini negativi si'.
      // Senza questi due il riquadro resta scorribile quanto la striscia NON
      // scalata -- 4.526 px sul guinzaglio contro i 1.399 disegnati -- e tre
      // quarti dello scorrimento portano sul vuoto (e' il difetto raccontato
      // qui sotto, che prima si copriva chiudendo lo scorrimento). Misurato:
      // scrollWidth passa da 4526 a 1399, cioe' esattamente il disegnato, e
      // lo scorrimento verticale di 104 px sparisce.
      wrap.style.marginRight = '-' + (largaW - largaW * scala).toFixed(1) + 'px';
      wrap.style.marginBottom = '-' + Math.max(0, altaW - altaW * scala).toFixed(1) + 'px';
      viewport.style.height = alta + 'px';
      tutta = scala <= fit + 1e-6;
      // A "tutta" non c'e' niente da scorrere: la striscia sta gia' tutta
      // dentro. Il riquadro pero' resta largo quanto la striscia NON scalata
      // esisteva ancora e portava solo sul vuoto: il riquadro nasceva a
      // scrollLeft 2088, cioe' a meta' di una larghezza che non c'era piu',
      // e la striscia finiva a -2068 px, fuori dallo schermo a sinistra --
      // ecco perche' sembrava che non ci fosse niente da personalizzare.
      // Adesso la causa e' tolta dai margini negativi qui sopra; questa riga
      // resta perche' a "tutta" non c'e' comunque nulla da scorrere.
      viewport.style.overflowX = tutta ? 'hidden' : 'auto';
      if (tutta) viewport.scrollLeft = 0;
      // All'apertura la striscia e' piu' larga della finestra: si parte dal
      // centro, che e' dove nasce il nome, e non dal primo mezzo metro vuoto.
      else if (appena) {
        viewport.scrollLeft = Math.max(0, (largaW * scala - finestra) / 2);
      }
      appena = false;
      customizer.setAttribute('data-nastro-zoom', tutta ? 'tutta' : 'ingrandita');
    }

    function cambia(fattore) {
      var prima = scala;
      scala = Math.max(fit, Math.min(massimo, scala * fattore));
      if (Math.abs(scala - prima) < 1e-6) return;
      toccata = true;
      // si ingrandisce attorno al centro di cio' che si sta guardando, non
      // attorno al bordo sinistro: altrimenti a ogni "+" si perde il punto
      var centro = (viewport.scrollLeft + viewport.clientWidth / 2) / prima;
      applica();
      // A "tutta" non c'e' niente da riposizionare: applica() ha gia' rimesso
      // il riquadro a zero, e rimetterlo altrove lo porterebbe sul vuoto --
      // che e' esattamente il difetto chiuso dai margini negativi.
      if (!tutta) {
        viewport.scrollLeft = Math.max(0, centro * scala - viewport.clientWidth / 2);
      }
    }

    // In cattura sul contenitore: si passa di qui prima che l'evento arrivi al
    // pulsante, e la propagazione si ferma. Vedi la nota sopra sul perche'
    // registrarsi sul pulsante non basta.
    customizer.addEventListener('click', function (e) {
      var b = e.target && e.target.closest
        ? e.target.closest('[data-view-zoom-in],[data-view-zoom-out],[data-view-zoom-reset]')
        : null;
      if (!b || !customizer.contains(b)) return;
      e.preventDefault();
      e.stopPropagation();
      if (b.hasAttribute('data-view-zoom-in')) cambia(PASSO);
      else if (b.hasAttribute('data-view-zoom-out')) cambia(1 / PASSO);
      // "ripristina" riporta alla misura d'apertura, non al filo: per vedere
      // tutto il prodotto in una volta c'e' lo zoom meno, che scende fino a fit.
      else { scala = apertura(); toccata = false; appena = true; applica(); }
    }, true);

    // `overflow:hidden` non impedisce a uno script di scorrere lo stesso
    // (un riquadro nascosto resta scorribile da codice): se succede, si torna
    // subito a zero. Quando e' ingrandita non si tocca: li' scorre l'utente.
    viewport.addEventListener('scroll', function () {
      if (tutta && viewport.scrollLeft !== 0) viewport.scrollLeft = 0;
    });

    // Rete di sicurezza: se lo stile diventa diverso da quello che abbiamo
    // scritto noi, lo si rimette. Il confronto con `atteso` fa si' che la
    // riscrittura non richiami l'osservatore all'infinito.
    new MutationObserver(function () {
      if (wrap.style.transform !== atteso) applica();
    }).observe(wrap, { attributes: true, attributeFilter: ['style'] });

    // Quando la finestra cambia misura, "tutta" cambia misura con lei.
    //
    // Non basta ascoltare `resize`: lo schermo intero di questo tema e' una
    // classe CSS, non l'API del browser, quindi il riquadro si allarga senza
    // che la finestra cambi e nessun `resize` arriva. Un ResizeObserver sul
    // riquadro li prende tutti e due -- rotazione e schermo intero -- perche'
    // guarda la cosa giusta: quanto spazio c'e' davvero.
    function rimisura() {
      var ora = viewport.clientWidth;
      if (!ora || ora === finestra) return;
      finestra = ora;
      var eraTutta = scala <= fit + 1e-6;
      fit = ora / largaW;
      // se non l'ha ancora toccata nessuno, la misura d'apertura si ricalcola
      // sulla finestra nuova (rotazione, schermo intero): e' quella giusta
      // per lo spazio che c'e' adesso, non quella giusta per lo spazio di prima.
      if (!toccata) { scala = apertura(); appena = true; }
      else { scala = eraTutta ? fit : Math.max(fit, scala); }
      applica();
    }
    if (typeof ResizeObserver === 'function') {
      new ResizeObserver(rimisura).observe(viewport);
    }
    window.addEventListener('resize', rimisura);
    window.addEventListener('orientationchange', function () {
      setTimeout(rimisura, 250);   // la rotazione arriva prima della nuova misura
    });

    applica();
    return { fit: fit, massimo: massimo };
  }

  function agganciaScrittura(F) {
    if (!F.IText || !F.IText.prototype || F.IText.prototype.__perlaTextarea) return;
    F.IText.prototype.__perlaTextarea = true;

    var creata = F.IText.prototype.initHiddenTextarea;
    F.IText.prototype.initHiddenTextarea = function () {
      var r = creata.apply(this, arguments);
      fissaTextarea(this);
      return r;
    };

    // Fabric la rimette al posto del cursore ogni volta che il cursore si
    // muove, quindi non basta sistemarla alla nascita.
    //
    // I DUE NOMI. In fabric 5.3 il metodo si chiama `updateTextareaPosition`,
    // senza trattino basso; nelle versioni piu' vecchie era `_update...`.
    // La prima stesura avvolgeva solo quello col trattino: la guardia
    // `typeof === 'function'` non trovava niente e passava oltre in silenzio,
    // e nella misura la textarea usciva con `left: 147.779px` invece di zero.
    // Si avvolgono tutti e due, e almeno uno dei due c'e' per forza.
    ['updateTextareaPosition', '_updateTextareaPosition'].forEach(function (nome) {
      var spostata = F.IText.prototype[nome];
      if (typeof spostata !== 'function') return;
      F.IText.prototype[nome] = function () {
        var r = spostata.apply(this, arguments);
        fissaTextarea(this);       // Fabric l'ha appena rimessa dove non deve
        return r;
      };
    });
  }

  function agganciaFabric() {
    var F = window.fabric;
    if (!F || !F.Canvas || !F.Canvas.prototype) return false;
    if (F.Canvas.prototype.__perlaAggancio) return true;
    F.Canvas.prototype.__perlaAggancio = true;
    var render = F.Canvas.prototype.renderAll;
    F.Canvas.prototype.renderAll = function () {
      if (!this.__perlaCurata) {
        try { prendiInCura(this); } catch (err) { this.__perlaCurata = true; }
      }
      return render.apply(this, arguments);
    };

    // La risoluzione del file di stampa. StaticCanvas e' l'antenato di Canvas:
    // avvolgerlo qui copre entrambi con un solo aggancio.
    var base = F.StaticCanvas && F.StaticCanvas.prototype;
    if (base && !base.__perlaRisoluzione) {
      base.__perlaRisoluzione = true;
      var esporta = base.toDataURL;
      base.toDataURL = function (opz) {
        // Nessun moltiplicatore = anteprima sullo schermo: non si tocca.
        if (!opz || opz.multiplier == null || opz.__perlaAlzato) {
          return esporta.apply(this, arguments);
        }
        var k = quantoSiPuoAlzare(this, opz.multiplier);
        if (k <= 1.0001) return esporta.apply(this, arguments);

        var prova = copia(opz);
        prova.__perlaAlzato = true;
        prova.multiplier = opz.multiplier * k;

        var url;
        try {
          url = esporta.call(this, prova);
        } catch (err) {
          return esporta.apply(this, arguments);   // memoria: si torna a prima
        }
        // Se il file e' troppo pesante per il caricamento si scende, fino al
        // massimo a quello che l'editor produceva prima: peggio di cosi' no.
        var giri = 0;
        while (byte(url) > BYTE_MAX && prova.multiplier > opz.multiplier && giri < 4) {
          giri++;
          prova.multiplier = Math.max(opz.multiplier, prova.multiplier / 1.5);
          try { url = esporta.call(this, prova); } catch (err) { break; }
        }
        return url;
      };
    }
    agganciaScrittura(F);
    return true;
  }

  function initLimiti() {
    if (agganciaFabric()) return;
    // global.js carica fabric.js da un CDN solo quando serve l'editor: puo'
    // arrivare molto dopo di noi. Si aspetta, ma non per sempre.
    var scade = Date.now() + 90000;
    var t = setInterval(function () {
      if (agganciaFabric() || Date.now() > scade) clearInterval(t);
    }, 200);
  }

  /* -------------------------------------------------------------------------
     10. IL RECESSO SI DICE PRIMA DI PAGARE, NON DOPO

     PERCHE' STA QUI E NON SOLO NELL'INFORMATIVA
     Sui beni confezionati su misura il diritto di recesso di quattordici
     giorni non si applica -- art. 59, comma 1, lettera c) del Codice del
     Consumo, che recepisce l'art. 16 della direttiva 2011/83/UE. Ma
     l'esclusione vale solo se il consumatore ne e' stato informato PRIMA di
     essere vincolato dal contratto. Scriverlo soltanto nella pagina Resi non
     basta: nessuno la apre prima di comprare.

     Se non lo si dice qui, l'esclusione non opera e un collare con sopra il
     nome del cane torna indietro entro quattordici giorni -- e lo paghiamo
     noi, perche' rivenderlo e' impossibile.

     DOVE
     In fondo al riquadro di personalizzazione, cioe' l'ultima cosa che si
     legge dopo aver scritto il nome e prima di premere "aggiungi al carrello".
     Non e' un avvertimento in rosso: e' la stessa frase che diremmo a voce a
     qualcuno che ci porge un collare da incidere.

     Compare SOLO dove esiste `[data-photo-customizer]`, cioe' esattamente sui
     prodotti personalizzabili: sugli altri non ha senso e non appare.
     ---------------------------------------------------------------------- */

  function initAvvisoRecesso(customizer) {
    if (qs(customizer, '[data-avviso-recesso]')) return;   // gia' messo

    var avviso = document.createElement('p');
    avviso.className = 'photo-studio__note';
    avviso.setAttribute('data-avviso-recesso', '');
    avviso.textContent = STR.recessoNote || (IT
      // Apostrofi tipografici e accenti veri: questo lo legge un cliente, non
      // e' un commento nel codice. La prima stesura diceva "non si puo'
      // restituire" con l'apostrofo al posto dell'accento, e in mezzo al resto
      // del sito -- che usa le virgolette curve ovunque -- si vedeva.
      ? 'Lo stampiamo apposta per te dopo l\u2019ordine: per legge un pezzo personalizzato non si pu\u00f2 restituire per ripensamento. Se arriva difettoso o sbagliato lo rifacciamo noi, spese comprese.'
      : 'We print it for you after you order, so by law a personalised item can\u2019t be returned for a change of mind. If it arrives faulty or wrong, we remake it at our cost.');

    customizer.appendChild(avviso);
  }

  /* --------------------------------------------------------------------------
     ROUND 20 -- I RITRATTI CHE NON CI STANNO NELLA LORO FINESTRA.

     Il riquadro dell'editor prende tutta la larghezza della colonna e ricava
     l'altezza dal rapporto dell'area di stampa. Sui prodotti piu' alti che
     larghi questo puo' sfondare il tetto della finestra -- che il foglio di
     stile fissa a min(560px, 62vh) -- e allora il fondo del disegno resta
     tagliato finche' non si scorre DENTRO il riquadro. Misurato a 1280x1000:

         medaglietta          583 px in una finestra di 560   -> 23 px tagliati
         medaglietta incisa   629 px in una finestra di 560   -> 69 px tagliati

     Si guarisce dalla larghezza, non dall'altezza: larghezza massima =
     tetto x rapporto, e l'altezza torna dentro da sola tenendo le proporzioni
     esatte. Sui prodotti larghi il limite e' piu' largo della colonna e non
     tocca niente (bandana 1041 px contro 524 disponibili).

     PERCHE' IN JAVASCRIPT E NON NEL CSS. A schermo intero la finestra non ha
     piu' tetto (`.pd-modal__body ... {max-height:none}`): un massimo scritto
     nello stile in linea vincerebbe sul foglio e terrebbe il riquadro piccolo
     proprio dove deve crescere. Qui invece il tetto si rilegge ogni volta, e
     quando non c'e' il limite si toglie.
     ---------------------------------------------------------------------- */
  function initAltezzaRitratto(customizer) {
    var coppie = [];
    each(customizer.querySelectorAll('[data-fabric-viewport]'), function (v) {
      var w = v.querySelector('[data-fabric-wrap]');
      if (w && !w.classList.contains('fabric-studio--nastro')) coppie.push({ v: v, w: w });
    });
    if (!coppie.length) return;

    function rapportoDi(w) {
      var a = getComputedStyle(w).aspectRatio || '';
      var n = a.split('/');
      var x = parseFloat(n[0]), y = n.length > 1 ? parseFloat(n[1]) : 1;
      return (x > 0 && y > 0) ? x / y : 0;
    }

    function adatta() {
      coppie.forEach(function (c) {
        var tetto = parseFloat(getComputedStyle(c.v).maxHeight);  // NaN se e' "none"
        var rap = rapportoDi(c.w);
        if (!rap || !isFinite(tetto) || tetto <= 0) {
          c.w.style.maxWidth = '';
          return;
        }
        c.w.style.maxWidth = (tetto * rap).toFixed(1) + 'px';
        c.w.style.marginLeft = 'auto';
        c.w.style.marginRight = 'auto';
      });
    }

    adatta();
    window.addEventListener('resize', adatta);
    window.addEventListener('orientationchange', function () { setTimeout(adatta, 250); });
    if (typeof ResizeObserver === 'function') {
      var o = new ResizeObserver(adatta);
      coppie.forEach(function (c) { o.observe(c.v); });
    }
  }

  /* ---------------------------------------------------------------------- */
  /* Lo sfondo delle strisce (collari, guinzagli) a piena misura. Il tema lo
     carica leggero (2208 px) e qui, a pagina caricata, si scarica il file
     intero (data-src-hd, vedi sections/main-product.liquid): col «+» la
     striscia si ingrandisce fino a sei volte e quello leggero diventa una
     poltiglia. Si sostituisce solo quando il file e' arrivato, quindi non si
     vede mai un riquadro vuoto; e solo se nessun altro ha gia' cambiato
     l'immagine (sui prodotti Printify global.js ci mette la sua anteprima). */
  function initSfondoPieno(customizer) {
    each(customizer.querySelectorAll('img[data-src-hd]'), function (img) {
      var hd = img.getAttribute('data-src-hd');
      var iniziale = img.getAttribute('src');
      if (!hd || !iniziale || img.hidden) return;
      function carica() {
        var pieno = new Image();
        pieno.onload = function () {
          if (img.getAttribute('src') === iniziale) img.setAttribute('src', hd);
        };
        pieno.src = hd;
      }
      if (document.readyState === 'complete') carica();
      else window.addEventListener('load', carica, { once: true });
    });
  }

  /* ---------------------------------------------------------------------- */
  function init() {
    each(document.querySelectorAll('[data-photo-customizer]'), function (c) {
      initWideHint(c);
      initSfondoPieno(c);
      initNastro(c);
      initAltezzaRitratto(c);
      initAvvisoRecesso(c);
      initDragAndDrop(c);
      initEmptyState(c);
      initMockupFeedback(c);
    });
    // Pannello mockup condiviso della medaglietta: vive fuori dai due editor
    // fronte/retro, quindi non e' coperto dal ciclo qui sopra.
    each(document.querySelectorAll('[data-shared-mockup]'), initMockupFeedback);
    initNameStyle();
    initGalleryClean();
    initLimiti();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
